module.exports = __webpack_public_path__ + "media/images/emblems/Vallorbe-coat_of_arms-5980960f91b4c0fc7613420df034891d.svg";